import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5910ca1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_6 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_7 = {
  for: "start-date",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_8 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_9 = {
  for: "end-date",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_10 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_11 = {
  for: "user-name",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_12 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_13 = { class: "block text-sm" }
const _hoisted_14 = { value: null }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "mt-10 flex flex-wrap items-end justify-between gap-4" }
const _hoisted_17 = { class: "flex items-center gap-4" }
const _hoisted_18 = { class: "flex flex-wrap items-end gap-4" }
const _hoisted_19 = { class: "flex flex-col items-center" }
const _hoisted_20 = {
  for: "page-size",
  class: "block text-sm text-gray-700"
}
const _hoisted_21 = ["value", "disabled"]
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "logs-user-id"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "ID", -1))
const _hoisted_25 = { class: "logs-date" }
const _hoisted_26 = { class: "flex flex-row-reverse" }

import { ref, onMounted, computed, reactive } from "vue";
import { useStore } from "vuex";
import { LogsActions } from "@/store/modules/logs/actions";
import { LogsGetters } from "@/store/modules/logs/getters";
import { SearchIcon } from "@heroicons/vue/outline";
import VueTableLite from "vue3-table-lite/ts";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { Button, TextButton } from "@/components/common";
import { getLocale, t } from "@/i18n";
import { formatDateTime } from "@/utils/date";
import { baseApiLogs } from "@/config/http-logs";
import { downloadBlob } from "@/utils/downloadBlob";
import { useToast } from "vue-toastification";
import PublicId from "@/components/common/PublicId.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const toast = useToast();

const dataProvider = computed(() => {
  return store.getters[LogsGetters.GET_DATA_PROVIDER];
});
const items = computed(() => {
  return dataProvider.value?.items || [];
});
const pager = computed(() => {
  return (
    dataProvider.value?.pager || {
      currentPage: 1,
      totalPages: 1,
      startPage: 1,
      endPage: 1,
    }
  );
});

const pageSizeOptions = [15, 25, 50, 100];
const pageSize = ref(25);
const exportLoading = ref(false);
const logStatuses = computed(() => ({
  SUCCESS: t("logs.status.success"),
  ERROR: t("logs.status.error"),
}));

const filter = ref({
  userInfo: "",
  startDate: null as Date | null,
  endDate: null as Date | null,
  status: null as string | null,
});

const formatFilterDate = (value: Date | null) => {
  if (!value) return undefined;
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const requestParams = () => ({
  userInfo: filter.value.userInfo.trim() || undefined,
  status: filter.value.status || undefined,
  startDate: formatFilterDate(filter.value.startDate),
  endDate: formatFilterDate(filter.value.endDate),
});

const getPage = async (page: number) => {
  if (table.isLoading) return;

  table.isLoading = true;
  try {
    await store.dispatch(LogsActions.FETCH_DATA_PROVIDER, {
      page: Number.isInteger(page) && page > 0 ? page : 1,
      size: pageSize.value,
      ...requestParams(),
    });
  } finally {
    table.isLoading = false;
  }
};

const changePageSize = async (event: Event) => {
  const nextSize = Number((event.target as HTMLSelectElement).value);
  if (!pageSizeOptions.includes(nextSize) || nextSize === pageSize.value) {
    return;
  }

  pageSize.value = nextSize;
  await getPage(1);
};

const updateFilter = async () => {
  await getPage(1);
};

const clearFilter = async () => {
  filter.value = {
    userInfo: "",
    startDate: null,
    endDate: null,
    status: null,
  };
  await getPage(1);
};

const logStatusLabel = (status: string) =>
  status === "SUCCESS"
    ? t("logs.status.success")
    : status === "ERROR"
    ? t("logs.status.error")
    : status;

const exportLogs = async () => {
  if (exportLoading.value) return;
  exportLoading.value = true;
  try {
    const response = await baseApiLogs.get(
      "/api/logs/user-logs/export",
      {
        params: requestParams(),
        responseType: "blob",
      }
    );
    const date = new Date().toISOString().slice(0, 10);
    downloadBlob(
      new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `user-logs-${date}.xlsx`
    );
  } catch {
    toast.error(t("logs.exportError"));
  } finally {
    exportLoading.value = false;
  }
};

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("logs.url"),
      field: "url",
      width: "22%",
      sortable: false,
    },
    {
      label: t("common.status"),
      field: "status",
      width: "110px",
      sortable: false,
    },
    {
      label: t("logs.user"),
      field: "userInfo",
      width: "200px",
      sortable: false,
    },
    {
      label: t("logs.message"),
      field: "message",
      sortable: false,
    },
    {
      label: t("logs.createdAt"),
      field: "createdAt",
      width: "155px",
      sortable: false,
    },
  ],
  rows: items,
  totalRecordCount: 0,
});

onMounted(async () => {
  await getPage(1);
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("logs.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("logs.dateFrom")), 1),
          _createVNode(_component_Datepicker, {
            id: "start-date",
            locale: _unref(getLocale)(),
            selectText: _unref(t)('logs.apply'),
            cancelText: _unref(t)('logs.cancel'),
            placeholder: _unref(t)('logs.datePlaceholder'),
            enableTimePicker: false,
            modelValue: filter.value.startDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.startDate) = $event)),
            format: "dd/MM/yyyy",
            previewFormat: "dd/MM/yyyy",
            autoApply: true
          }, null, 8, ["locale", "selectText", "cancelText", "placeholder", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("logs.dateTo")), 1),
          _createVNode(_component_Datepicker, {
            id: "end-date",
            locale: _unref(getLocale)(),
            selectText: _unref(t)('logs.apply'),
            cancelText: _unref(t)('logs.cancel'),
            placeholder: _unref(t)('logs.datePlaceholder'),
            enableTimePicker: false,
            modelValue: filter.value.endDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.endDate) = $event)),
            format: "dd/MM/yyyy",
            previewFormat: "dd/MM/yyyy",
            autoApply: true
          }, null, 8, ["locale", "selectText", "cancelText", "placeholder", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)("logs.user")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "user-name",
            type: "search",
            class: "w-full flex-none w-2/5 rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.userInfo) = $event))
          }, null, 512), [
            [_vModelText, filter.value.userInfo]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("common.status")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "user-status",
            name: "user-status",
            class: "block w-full flex-1 rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.status) = $event))
          }, [
            _createElementVNode("option", _hoisted_14, _toDisplayString(_unref(t)("common.allStatuses")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logStatuses), (status, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: index,
                key: index
              }, _toDisplayString(status), 9, _hoisted_15))
            }), 128))
          ], 512), [
            [_vModelSelect, filter.value.status]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_unref(Button), {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateFilter())),
            class: "btn-search"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(TextButton), { onClick: clearFilter }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.clear")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)("logs.pageSize")), 1),
            _createElementVNode("select", {
              id: "page-size",
              value: pageSize.value,
              class: "block w-24 rounded-lg border-gray-300",
              disabled: _unref(table).isLoading,
              onChange: changePageSize
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (size) => {
                return _createElementVNode("option", {
                  key: size,
                  value: size
                }, _toDisplayString(size), 9, _hoisted_22)
              }), 64))
            ], 40, _hoisted_21)
          ]),
          _createVNode(_unref(Button), {
            class: "flex px-6",
            disabled: exportLoading.value,
            onClick: exportLogs
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("logs.export")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createVNode(_unref(VueTableLite), {
      class: "logs-table",
      "data-pagination-scroll-anchor": "",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      messages: { noDataAvailable: _unref(t)('common.noData') }
    }, {
      status: _withCtx((data) => [
        _createElementVNode("span", {
          class: _normalizeClass(["tag", 
            data.value.status === 'SUCCESS' ? 'tag--success' : 'tag--error'
          ])
        }, _toDisplayString(logStatusLabel(data.value.status)), 3)
      ]),
      userInfo: _withCtx((data) => [
        _createElementVNode("div", null, _toDisplayString(data.value.userInfo), 1),
        (data.value.userPublicId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(PublicId, {
                value: data.value.userPublicId,
                compact: ""
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true)
      ]),
      createdAt: _withCtx((data) => [
        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(formatDateTime)(data.value.createdAt)), 1)
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "total-pages": _unref(pager).totalPages,
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ])
  ]))
}
}

})